import ApprovalConfigForm from '@/febos/global/rules/components/approvals/ApprovalConfigForm';

export const ACTION_TYPES = {
  APPROVAL: 'approval',
  // EMAIL: 'email'
};
export const ACTION_TYPES_NAMES = {
  [ACTION_TYPES.APPROVAL]: 'Aprobar',
  // [ACTION_TYPES.EMAIL]: 'Enviar Email'
};

export const ACTION_REQUIRED_CONFIG = {
  [ACTION_TYPES.APPROVAL]: {
    title: 'Configurar aprobación',
    form: ApprovalConfigForm
  },
};
